/* A pilot presentation layer only; never writes catalog, stock, prices or cart. */
(() => {
  const root = document.querySelector('[data-alpine-pdp-pilot]');
  if (!root || root.dataset.pilotReady) return;
  root.dataset.pilotReady = 'true';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const pausedByUser = new WeakSet();
  const observed = new WeakSet();
  const form = root.querySelector('form[action*="/cart/add"]');
  const info = root.querySelector('.product-single__meta');
  const purchase = root.querySelector('fieldset[data-index="option2"]')?.closest('.variant-wrapper') || info;
  if (purchase) purchase.id = 'alpine-pilot-purchase';
  let active = null, visible = false, playButton = null;
  const canPlay = v => v && !reduce.matches && !document.hidden && visible &&
    v.classList.contains('is-current') && !pausedByUser.has(v) && !root.querySelector('dialog[open]');
  const label = () => {
    if (!playButton) return;
    playButton.hidden = !active;
    playButton.textContent = !active || active.paused ? '播放影片' : '暫停影片';
    playButton.setAttribute('aria-label', playButton.textContent);
  };
  const syncPlayback = () => {
    if (!active) return label();
    if (canPlay(active)) active.play().catch(label);
    else active.pause();
    label();
  };
  const visibility = new IntersectionObserver(entries => {
    for (const e of entries) if (e.target === active) {
      visible = e.isIntersecting && e.intersectionRatio >= .15;
      syncPlayback();
    }
  }, {threshold:[0,.15,.5]});
  const bindGallery = () => {
    const gallery = root.querySelector('.tz-colour-gallery');
    const stage = gallery?.querySelector('.tz-colour-gallery__stage');
    if (!stage) return;
    gallery.querySelectorAll('.tz-colour-gallery__arrow:not([data-pilot-icon])').forEach(button => {
      button.dataset.pilotIcon='true';
      const previous=button.hasAttribute('data-tz-gallery-previous');
      button.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="'+(previous?'M19 12H5m6-6-6 6 6 6':'M5 12h14m-6-6 6 6-6 6')+'"/></svg>';
    });
    if (!playButton) {
      playButton = document.createElement('button');
      playButton.type = 'button';
      playButton.className = 'alpine-pilot-motion';
      playButton.hidden = true;
      stage.append(playButton);
      playButton.addEventListener('click', () => {
        if (!active) return;
        if (active.paused) {
          pausedByUser.delete(active);
          active.play().catch(label);
        } else {
          pausedByUser.add(active);
          active.pause();
        }
        label();
      });
    }
    const next = stage.querySelector('video.is-current');
    if (active !== next) {
      active?.pause();
      active = next;
      visible = false;
      if (active) {
        active.loop = true;
        active.muted = true;
        active.defaultMuted = true;
        active.playsInline = true;
        active.autoplay = !reduce.matches;
        active.controls = reduce.matches;
        active.setAttribute('playsinline','');
        if (!observed.has(active)) {
          observed.add(active);
          active.addEventListener('play',label);
          active.addEventListener('pause',label);
          visibility.observe(active);
        }
        const box = active.getBoundingClientRect();
        visible = box.bottom > 0 && box.top < innerHeight && box.height > 0;
        syncPlayback();
      }
      label();
    }
  };
  // Watch only gallery replacement/classes; no repeated network requests or polling.
  const galleryObserver = new MutationObserver(bindGallery);
  galleryObserver.observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  bindGallery();
  document.addEventListener('visibilitychange',syncPlayback);
  reduce.addEventListener('change',() => {
    if(active) {active.autoplay=!reduce.matches;active.controls=reduce.matches;}
    syncPlayback();
  });
  const dock = document.createElement('aside');
  dock.className = 'alpine-pilot-dock';
  dock.setAttribute('aria-label','商品購買捷徑');
  const copy = document.createElement('div');
  copy.className = 'alpine-pilot-dock-copy';
  const title = document.createElement('strong');
  const productTitle = root.querySelector('.product-single__title')?.textContent.trim() || '';
  title.textContent = productTitle.replace(/Snow Trousers(?: 2(?:\.0)?)/g,'Snow Trousers').replace(/Storm Trousers(?: 2(?:\.0)?)/g,'Storm Trousers');
  const price = document.createElement('span');
  copy.append(title,price);
  const link = document.createElement('a');
  link.href = '#alpine-pilot-purchase';
  link.textContent = root.querySelector('fieldset[data-index="option2"]') ? '選擇尺寸' : '選擇款式';
  link.addEventListener('click',e => {
    if(!purchase) return;
    e.preventDefault();
    purchase.scrollIntoView({behavior:reduce.matches?'auto':'smooth',block:'center'});
    const size = root.querySelector('[data-index="option2"] input:not(:disabled)');
    if(size) size.focus({preventScroll:true});
  });
  dock.append(copy,link);
  document.body.append(dock);
  let formVisible = false;
  const syncDock = () => {
    const p = root.querySelector('[data-product-price]');
    price.textContent = p?.textContent.replace(/\s+/g,' ').trim() || '';
    const dialog = document.querySelector('dialog[open],.modal--is-active,.drawer--is-open,[data-tool-tip-open="true"]');
    dock.hidden = formVisible || !!dialog;
  };
  const purchaseObserver = new IntersectionObserver(entries => {
    formVisible = entries.some(e=>e.isIntersecting);
    syncDock();
  }, {threshold:0});
  if(form) purchaseObserver.observe(form);
  root.addEventListener('change',()=>requestAnimationFrame(syncDock));
  document.addEventListener('alpine:zoom-close',syncDock);
  new MutationObserver(syncDock).observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','class','data-tool-tip-open']});
  syncDock();
  // Preserve the existing review routes for the accompanying products.
  const syncRelatedRoutes = () => document.querySelectorAll('a.alpine-story-related-card').forEach(a => {
    const url = new URL(a.href, location.origin);
    if(url.origin === location.origin && url.searchParams.get('view') === 'alpine-native') {
      url.searchParams.set('view','alpine-family-design-review');
      a.href = url.href;
    }
  });
  syncRelatedRoutes();
  const story = document.querySelector('[data-pilot-story],.alpine94-story');
  if(story) new MutationObserver(syncRelatedRoutes).observe(story,{subtree:true,attributes:true,attributeFilter:['href'],childList:true});
})();

/* Product-verified version comparison near the first product option. */
(() => {
 const root=document.querySelector('[data-alpine-native-pdp]');
 const id=root?.querySelector('[data-product-id]')?.dataset.productId;
 if(!['8658218188996','8392837693636','8092197355716','7561855336644'].includes(id)||root.querySelector('[data-alpine-version-comparison]'))return;
 const option=root.querySelector('.product-single__meta .variant-wrapper');
 if(!option)return;
 const details=document.createElement('details');details.setAttribute('data-alpine-version-comparison','');
 const summary=document.createElement('summary');summary.textContent='3.0 與上一代怎麼選？';details.append(summary);
 const p=document.createElement('p');p.textContent='3.0 加入三段胸口照明與可拆式 POV 攝影口袋。上一代 Ultra Jacket、Ultra Coat 2.0 與 3.0 都有三段加熱及 20K／20K 防水透濕。';details.append(p);
 option.before(details);
})();


/* One complete product description/size disclosure, before the option comparison. */
(() => {
  const root = document.querySelector('[data-alpine-native-pdp]');
  if (!root) return;
  const info = root.querySelector('.product-single__meta');
  if (!info) return;
  const consolidate = () => {
    let primary = info.querySelector('.alpine94-native-description');
    if (!primary) {
      const local = [...root.querySelectorAll('details')];
      const size = local.find(node => node.querySelector('summary')?.textContent.trim() === '版型與尺寸');
      const features = local.find(node => node.querySelector('summary')?.textContent.trim() === '機能與材質');
      if (size && features) {
        const fuller = [...document.querySelectorAll('.pilot-info > details')]
          .find(node => node.querySelector('summary')?.textContent.trim() === '產品特點');
        if (fuller) {
          [...features.children].filter(node => node.tagName !== 'SUMMARY').forEach(node => node.remove());
          [...fuller.children].filter(node => node.tagName !== 'SUMMARY').forEach(node => features.append(node));
          fuller.remove();
        }
        [...size.children].filter(node => node.tagName !== 'SUMMARY').forEach(node => features.append(node));
        size.remove();
        primary = features;
      }
    }
    const extras = [...document.querySelectorAll('[data-family-shopping] .pilot-info > details')]
      .filter(node => node.querySelector('summary')?.textContent.trim() === '產品特點與尺寸');
    const detail = primary || extras[0];
    const anchor = info.querySelector('[data-alpine-version-comparison]') || info.querySelector('.variant-wrapper');
    if (!detail || !anchor) return;
    if (detail.nextElementSibling !== anchor) anchor.before(detail);
    const summary = detail.querySelector('summary');
    if (summary && summary.textContent !== '商品說明與尺寸') summary.textContent = '商品說明與尺寸';
    detail.classList.add('alpine94-native-description');
    extras.filter(node => node !== detail).forEach(node => node.remove());
  };
  consolidate();
  const observer = new MutationObserver(consolidate);
  observer.observe(document.querySelector('#MainContent') || root, {childList:true,subtree:true});
  window.addEventListener('pagehide', () => observer.disconnect(), {once:true});
})();

